import { render, staticRenderFns } from "./IconPipet.vue?vue&type=template&id=6623e98b&"
import script from "./IconPipet.vue?vue&type=script&lang=ts&"
export * from "./IconPipet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports